/**
 * Where the server is. On the web the app is served by the Worker (or Vite's proxy in development),
 * so the API is same-origin. The native shells bundle the app and point VITE_API_URL at the server.
 */
const configured = import.meta.env.VITE_API_URL?.replace(/\/$/, '') ?? '';

export const apiBase = (): string => `${configured}/api`;

export function liveUrl(worldId: string, token: string): string {
  const base = configured || location.origin;
  const url = new URL(`${base}/api/crews/${encodeURIComponent(worldId)}/live`);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.searchParams.set('token', token);
  return url.toString();
}
